export const STOCK_ROLE_ACCESS_COLLAPSED_KEY = 'oms.stockRoleAccessCollapsed'

export const readStockRoleAccessCollapsedChoice = (
  storage = typeof localStorage === 'undefined' ? null : localStorage,
) => {
  if (!storage?.getItem) return null
  try {
    const raw = storage.getItem(STOCK_ROLE_ACCESS_COLLAPSED_KEY)
    if (raw === 'true') return true
    if (raw === 'false') return false
    return null
  } catch {
    return null
  }
}

export const writeStockRoleAccessCollapsedChoice = (
  collapsed,
  storage = typeof localStorage === 'undefined' ? null : localStorage,
) => {
  if (!storage?.setItem) return collapsed
  try {
    storage.setItem(
      STOCK_ROLE_ACCESS_COLLAPSED_KEY,
      collapsed ? 'true' : 'false',
    )
  } catch {
    // Private mode / quota.
  }
  return collapsed
}

/** Admin starts collapsed; chefs start open. Stored choice always wins. */
export const stockRoleAccessStartsCollapsed = ({
  storedCollapsed,
  isAdmin,
} = {}) => {
  if (storedCollapsed === true) return true
  if (storedCollapsed === false) return false
  return Boolean(isAdmin)
}
